import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { PageType } from '../NawImmoraum'

type Props = {
  pages: PageType[]
  currentPage: PageType
}

const Progress = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress}%;
`

const ProgressBar: React.FC<Props> = ({ pages, currentPage }) => {
  const [progress, setProgress] = useState<number>(0)

  useEffect(() => {
    if (!!pages && !!currentPage) {
      const index = pages.findIndex((p) => p === currentPage)
      const progress = Math.round((index / pages.length) * 100)

      setProgress(progress + 100 / pages.length)
    }
  }, [pages, currentPage])

  if (progress === 0) return null
  return (
    <div className="fixed left-0 h-2 md:h-3 w-full top-16 z-10">
      <Progress className="absolute bottom-0 h-full transition-all bg-green flex items-center justify-center" progress={progress}></Progress>
    </div>
  )
}

export default ProgressBar
